/* component-bottom-cart-bar.js — extracted from snippets/bottom-cart-bar.liquid */
function renderBottomCartBar(cart) {
    const bar = document.getElementById('desktop-bottom-cart-bar');
    if (!bar) return;

    if (!cart || cart.item_count === 0) {
      bar.classList.remove('is-visible');
      return;
    }

    bar.classList.add('is-visible');

    // Update Counts & Prices
    const countEl = document.getElementById('bottom-bar-item-count');
    const pluralEl = document.getElementById('bottom-bar-item-plural');
    const subtotalEl = document.getElementById('bottom-bar-subtotal-val');
    const checkoutPriceEl = document.getElementById('bottom-bar-checkout-price');
    // Use the shared formatter: it honours every money_format placeholder and
    // the shop's own separators. The old code hardcoded a currency symbol as
    // its fallback and used the browser locale for separators.
    let formattedPrice;
    if (window.theme && typeof window.theme.formatMoney === 'function') {
      formattedPrice = window.theme.formatMoney(cart.total_price);
    } else {
      formattedPrice = (cart.total_price / 100).toFixed(2);
    }

    if (countEl) countEl.textContent = cart.item_count;
    if (pluralEl) pluralEl.textContent = cart.item_count === 1 ? 'ITEM' : 'ITEMS';
    /* Money can carry markup. Currency apps ask merchants to set the money
     format to <span class=money>{{amount}}</span> so they can find and
     convert prices, so anything built from shop.money_format or the money
     filter has to be written as HTML - textContent would escape the span
     and print the tags on the page. The value is a shop setting plus a
     number this theme formatted, never shopper input. */
    if (subtotalEl) subtotalEl.innerHTML = formattedPrice;
    if (checkoutPriceEl) checkoutPriceEl.innerHTML = `&bull; ${formattedPrice}`;

    // Update Thumbnails List
    const thumbsList = document.getElementById('bottom-bar-thumbs-list');
    if (thumbsList && cart.items) {
      const displayItems = cart.items.slice(0, 4);
      const remainingCount = cart.items.length - 4;

      let thumbsHtml = displayItems.map(item => `
        <div class="bottom-cart-thumb-item" title="${item.title}">
          <img src="${item.featured_image ? item.featured_image.url : ''}" alt="${item.title}" class="bottom-cart-thumb-img" width="50" height="66">
        </div>
      `).join('');

      if (remainingCount > 0) {
        thumbsHtml += `<div class="bottom-cart-thumb-more">+${remainingCount}</div>`;
      }

      thumbsList.innerHTML = thumbsHtml;
    }
  }

  function syncBottomCartState() {
    fetch(window.themeRoutes.cart + '.js?_t=' + Date.now(), { cache: 'no-store' })
      .then(res => res.json())
      .then(cart => {
        renderBottomCartBar(cart);
        // Badge syncing lives in theme.js; announcing is enough.
        document.dispatchEvent(
          new CustomEvent('cart:updated', { detail: { cart: cart } })
        );
      })
      .catch(() => {});
  }

  // Hook into initial page load, bfcache back-forward restoration, focus, and visibility
  document.addEventListener('DOMContentLoaded', syncBottomCartState);
  document.addEventListener('shopify:section:load', syncBottomCartState);
  if (document.readyState !== 'loading') syncBottomCartState();
  window.addEventListener('pageshow', () => { syncBottomCartState(); });
  window.addEventListener('focus', syncBottomCartState);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') syncBottomCartState();
  });
  window.addEventListener('cart:updated', (e) => {
    if (e.detail && e.detail.cart) renderBottomCartBar(e.detail.cart);
    else syncBottomCartState();
  });
